<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="FRONTMATTER">
<p class="h2" id="ded"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><a href="#/text/9780062796776_Contents#rded"><b>Dedication</b></a></span></p>
<p class="ded3"><i>Dedicated to all the thought-provoking, freethinking, truth-telling women</i></p>
<p class="ded"><i>of past and present, beginning with my own fiery mother, Merri Louise</i></p>
<p class="ded"><i>Asebedo, who showed me how to blaze a trail of my own</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062796776_Dedication.vue?0bf29bc6